import React from 'react'

function SortList ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='15.238' height='16' viewBox='0 0 15.238 16'>
      <path d='M2.286,4.571A2.286,2.286,0,1,1,4.571,2.286,2.286,2.286,0,0,1,2.286,4.571Zm0-3.81A1.524,1.524,0,1,0,3.81,2.286,1.528,1.528,0,0,0,2.286.762Zm0,0' />
      <path d='M2.286,164.571a2.286,2.286,0,1,1,2.286-2.286A2.286,2.286,0,0,1,2.286,164.571Zm0-3.81a1.524,1.524,0,1,0,1.524,1.524A1.528,1.528,0,0,0,2.286,160.762Zm0,0' transform='translate(0 -154.286)' />
      <path d='M2.286,324.571a2.286,2.286,0,1,1,2.286-2.286A2.286,2.286,0,0,1,2.286,324.571Zm0-3.81a1.524,1.524,0,1,0,1.524,1.524A1.528,1.528,0,0,0,2.286,320.762Zm0,0' transform='translate(0 -308.571)' />
      <path d='M160,53.332h9.524v.762H160Zm0,0' transform='translate(-154.286 -51.427)' /><path d='M160,213.332h9.524v.762H160Zm0,0' transform='translate(-154.286 -205.713)' />
      <path d='M160,373.332h9.524v.762H160Zm0,0' transform='translate(-154.286 -359.999)' />
    </svg>
  )
}

SortList.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default SortList
